import { FC } from 'react';
import { Input, InputFieldType } from '@app/form_components';
import { useObjectForm } from '@app/hooks';

export type NodeFooterProps = {
  getControlProps: ReturnType<typeof useObjectForm>['getControlProps'];
};

export const NodeFooter: FC<NodeFooterProps> = ({
  getControlProps
}) => {
  const labels = window.l.property;

  return (
    <>
      <hr />
      <Input
        {...getControlProps('note')}
        label={labels.note}
        type={InputFieldType.textarea}
      />
    </>
  );
};
